import {
  put, takeLatest, call, all, fork, select,
} from 'redux-saga/effects';

import actions from '../actions/commission';
import rf from '../../requests/RequestFactory';

// saga effect
import {
  FETCH_COMMISSION,
  FETCH_COMMISSION_BY_TIME,
} from '../actions/commission/action_types';

import {
  getCoins,
} from './saga_selector';

function* fetchCommission(action) {
  try {
    const { data } = yield call(() => rf.getRequest('CommissionRequest').fetchCommission());
    const makeColorData = [];
    const coins = yield select(getCoins);
    for (const [key] of Object.entries(coins)) {
      makeColorData.push({ coin_name: key, value: 0 });
    }
    if (data.length !== 0) {
      data.forEach((item) => {
        const index = makeColorData.indexOf(makeColorData.find((element) => element.coin_name === item.coin_name));
        makeColorData[index] = item;
      });
    }

    yield put(actions.onFetchCommissionSuccess(makeColorData));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.onFetchCommissionFail());
  }
}

function* fetchCommissionByTime(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('CommissionRequest').fetchCommissionByTime(params), action.data);
    const makeColorData = [];
    const coins = yield select(getCoins);
    for (const [key, value] of Object.entries(coins)) {
      makeColorData.push({ coin_name: key, value: 0 });
    }
    if (data.length !== 0) {
      data.forEach((item) => {
        const index = makeColorData.indexOf(makeColorData.find((element) => element.coin_name === item.coin_name));
        makeColorData[index] = item;
      });
      yield put(actions.onFetchCommissionRangeSuccess(makeColorData));
    } else {
      yield put(actions.onFetchCommissionRangeSuccess(makeColorData));
    }
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.onFetchCommissionFail());
  }
}

function* watchAllUsers() {
  yield takeLatest(FETCH_COMMISSION, fetchCommission);
  yield takeLatest(FETCH_COMMISSION_BY_TIME, fetchCommissionByTime);
}

export default function* rootSaga() {
  yield all([fork(watchAllUsers)]);
}
